import { EuiButton, EuiButtonIcon, EuiPopover } from '@elastic/eui';
import React, {useState } from 'react';
import { InfoCPUser } from './container';
import './styles.css';

export const RepartosCPUserComponent = (props) =>{

    const {labelButton, params} = props
    
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const onButtonClick = () =>{
        setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
      }

       
      const closePopover = () => setIsPopoverOpen(false);
    
      const button = (labelButton===undefined) ? (<EuiButtonIcon iconType="iInCircle"/>) : (<EuiButton className='btnPopooverGrid' onClick={onButtonClick}>{`${labelButton}`}</EuiButton>);

    return(
        <EuiPopover
        className="popoverCell"
        ownFocus
        button={button}
        isOpen={isPopoverOpen}
        closePopover={closePopover}>
          <InfoCPUser params={params}/>
        </EuiPopover>
    )
}